// src/components/Footer/Footer.jsx

import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaInstagram, FaTiktok } from "react-icons/fa6";
import "./Footer.css";

const SOCIAL_LINKS = [
  {
    id: "instagram",
    label: "Instagram",
    href: "#", // Reemplazar por el Instagram oficial de ZY
    icon: FaInstagram,
  },
  {
    id: "tiktok",
    label: "TikTok",
    href: "#", // Reemplazar por el TikTok oficial de ZY
    icon: FaTiktok,
  },
];

export default function Footer() {
  const { t } = useTranslation("footer");

  const sections = [
    {
      title: t("sections.aprende.title"),
      links: [
        {
          label: t("sections.aprende.links.1"),
          href: "/cursos",
        },
        {
          label: t("sections.aprende.links.0"),
          href: "/guias",
        },
        {
          label: t("sections.aprende.links.2"),
          href: "/herramientas",
        },
      ],
    },
    {
      title: t("sections.explora.title"),
      links: [
        {
          label: t("sections.explora.links.0"),
          href: "/becas",
        },
        {
          label: t("sections.explora.links.1"),
          href: "/viviendas",
        },
      ],
    },
    {
      title: t("sections.sobreZY.title"),
      links: [
        {
          label: t("sections.sobreZY.links.1"),
          href: "/quienes-somos",
        },
        {
          label: t("sections.sobreZY.links.0"),
          href: "/preguntas-frecuentes",
        },
      ],
    },
    {
      title: t("sections.ayuda.title"),
      links: [
        {
          label: t("sections.ayuda.links.0"),
          href: "/contacto",
        },
        {
          label: t("sections.ayuda.links.1"),
          href: "/terminos-de-servicio",
        },
        {
          label: t("sections.ayuda.links.2"),
          href: "/politica-de-privacidad",
        },
      ],
    },
  ];

  return (
    <footer className="zy-footer">
      <div className="zy-footer__inner">
        <nav
          className="zy-footer__grid"
          aria-label="Navegación del pie de página"
        >
          {sections.map((section) => (
            <div key={section.title} className="zy-footer__col">
              <h4>{section.title}</h4>

              {section.links.map((link) => (
                <Link key={link.href} to={link.href}>
                  {link.label}
                </Link>
              ))}
            </div>
          ))}
        </nav>

        <hr className="zy-footer__divider" />

        <div className="zy-footer__bottom">
          <div className="zy-footer__brand">
            <p>
              <strong>ZY</strong>
              <span>{t("slogan")}</span>
            </p>
          </div>

          <nav className="zy-footer__socials" aria-label="Redes sociales de ZY">
            {SOCIAL_LINKS.map((social) => {
              const Icon = social.icon;

              return (
                <a
                  key={social.id}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Visitar ZY en ${social.label}`}
                >
                  <Icon aria-hidden="true" />

                  <span>{social.label}</span>
                </a>
              );
            })}
          </nav>

          <p className="zy-footer__copyright">{t("copyright")}</p>
        </div>
      </div>
    </footer>
  );
}
